goog.provide("shadow.js.shim.module$src$svg$type$ad_format$meta_single_image_svg$default");
shadow.js.shim.module$src$svg$type$ad_format$meta_single_image_svg$default = shadow.js.shim.module$src$svg$type$ad_format$meta_single_image_svg.default;
